var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("KendoGridColumnsEditorDialog", {
        attrs: {
          propOpened: _vm.kendoGridColumnsEditorDialogOpened,
          propGrid: _vm.Grid,
        },
        on: {
          "close-dialog": function ($event) {
            _vm.kendoGridColumnsEditorDialogOpened = false
          },
        },
      }),
      _vm._v(" "),
      _c("ScoringVotesSourceSelectorDialog", {
        attrs: {
          propOpened: _vm.scoringVotesSourceSelectorDialog.opened,
          propDefaultSurveyId:
            _vm.scoringVotesSourceSelectorDialog.defaultSurveyId,
          propDefaultProjectUserId:
            _vm.scoringVotesSourceSelectorDialog.defaultProjectUserId,
          propSurveys: _vm.surveys,
          propProjectUsers: _vm.projectUsers,
        },
        on: {
          "confirm-selection": _vm.changeScoringVotesSource,
          "load-panelists": _vm.loadScoringPanelists,
          "close-dialog": function ($event) {
            _vm.scoringVotesSourceSelectorDialog.opened = false
          },
        },
      }),
      _vm._v(" "),
      _c("SaveToAttributeDialog", {
        attrs: { viewModel: _vm.saveToAttributeDialog },
        on: {
          "save-new-attribute": _vm.handleSaveResultsToNewAttributeCommand,
          "save-existing-attribute":
            _vm.handleSaveResultsToExistingAttributeCommand,
        },
      }),
      _vm._v(" "),
      _c("BarChartDialog", { attrs: { viewModel: _vm.barChartDialog } }),
      _vm._v(" "),
      _c("RadarChartDialog", { attrs: { viewModel: _vm.radarChartDialog } }),
      _vm._v(" "),
      _c("SensitivityAnalysisChartDialog", {
        attrs: { viewModel: _vm.sensitivityAnalysisChartDialog },
      }),
      _vm._v(" "),
      _c("CriterionSelectorDialog", {
        attrs: { viewModel: _vm.criterionSelectorDialog },
        on: { "confirm-selection": _vm.changeCriterion },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          !_vm.rm
            ? _c("h3", [
                _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                _vm._v(" Loading... "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.rm
            ? _c(
                "div",
                [
                  _c("h3", [_vm._v("Goal: " + _vm._s(_vm.goalName))]),
                  _c("br"),
                  _vm._v(" "),
                  _c("GoalNavigation", {
                    attrs: {
                      WorkspaceId: _vm.workspaceId,
                      ProjectId: _vm.projectId,
                      EvalModelId: _vm.evalModelId,
                      ActivePage: "results",
                      ScoringEnabled: _vm.rm.ScoringEnabled,
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-deck" }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("h5", { staticClass: "card-title" }, [
                          _vm._v("Ranking"),
                        ]),
                        _vm._v(" "),
                        _c("p"),
                        _c("div", { staticClass: "dropdown" }, [
                          _vm._v("\n                                List: "),
                          _c(
                            "a",
                            {
                              staticClass: "text-primary",
                              attrs: { "data-toggle": "dropdown" },
                            },
                            [_vm._v(_vm._s(_vm.selectedList?.Name ?? "All"))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu",
                              staticStyle: {
                                "max-height": "250px",
                                "overflow-y": "auto",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeViewDef(null)
                                    },
                                  },
                                },
                                [_vm._v("All")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c("h6", { staticClass: "dropdown-header" }, [
                                _vm._v("Custom lists"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.lists, function (l) {
                                return _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeViewDef(l.Id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(l.Name))]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p"),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("Rank by: "),
                          _c(
                            "a",
                            {
                              staticClass: "text-primary",
                              on: { click: _vm.showCriterionSelectorDialog },
                            },
                            [_vm._v(_vm._s(_vm.selectedCriterion?.Name))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown d-inline-block" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary btn-sm dropdown-toggle",
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                                disabled: _vm.dataReady === false,
                              },
                            },
                            [
                              _vm._v(
                                "\n                                Save to attribute\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: _vm.showScoreToAttributeSaverDialog,
                                },
                              },
                              [_vm._v("Value score")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: _vm.showRankToAttributeSaverDialog,
                                },
                              },
                              [_vm._v("Rank position")]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown d-inline-block" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary btn-sm dropdown-toggle",
                              attrs: { "data-toggle": "dropdown" },
                            },
                            [_vm._v(_vm._s(_vm.precisionLabel))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c("h6", { staticClass: "dropdown-header" }, [
                              _vm._v("Precision:"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.changePrecision(0)
                                  },
                                },
                              },
                              [_vm._v("1.0")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.changePrecision(1)
                                  },
                                },
                              },
                              [_vm._v("0.1")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.changePrecision(2)
                                  },
                                },
                              },
                              [_vm._v("0.01")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.changePrecision(3)
                                  },
                                },
                              },
                              [_vm._v("0.001")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.changePrecision(4)
                                  },
                                },
                              },
                              [_vm._v("0.0001")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.changePrecision(5)
                                  },
                                },
                              },
                              [_vm._v("0.00001")]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _c("h5", { staticClass: "card-title" }, [
                            _vm._v("Data"),
                          ]),
                          _vm._v(" "),
                          _vm.weightsSets.length === 0 ? [_vm._m(0)] : _vm._e(),
                          _vm._v(" "),
                          _vm.weightsSets.length > 0
                            ? [
                                _c("p"),
                                _c("div", { staticClass: "dropdown" }, [
                                  _vm._v(
                                    "\n                                    Weights: "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "text-primary dropdown-toggle",
                                      attrs: { "data-toggle": "dropdown" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedWeightsSet?.Name ?? "None"
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "dropdown-menu" },
                                    _vm._l(_vm.weightsSets, function (ws) {
                                      return _c(
                                        "a",
                                        {
                                          key: ws.Id,
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.changeWeightsSet(ws.Id)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(ws.Name))]
                                      )
                                    }),
                                    0
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p"),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Scores: "),
                            _c(
                              "a",
                              {
                                staticClass: "text-primary",
                                on: {
                                  click:
                                    _vm.showScoringVotesSourceSelectorDialog,
                                },
                              },
                              [_vm._v(_vm._s(_vm.selectedScoresSourceLabel))]
                            ),
                          ]),
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "h2",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.dataReady === false,
                          expression: "dataReady === false",
                        },
                      ],
                    },
                    [
                      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                      _vm._v(" Loading data..."),
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.dataReady === true,
                          expression: "dataReady === true",
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "mb-1 d-flex justify-content-end" },
                        [
                          _c(
                            "div",
                            { staticClass: "dropdown d-inline-block mr-1" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-sm btn-outline-secondary dropdown-toggle",
                                  attrs: { "data-toggle": "dropdown" },
                                },
                                [
                                  _vm._v(
                                    "\n                            Compare (" +
                                      _vm._s(_vm.selectedAlternatives.length) +
                                      ")\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-menu" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: { click: _vm.showBarChartDialog },
                                  },
                                  [_vm._v("Bar chart")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: { click: _vm.showRadarChartDialog },
                                  },
                                  [_vm._v("Radar chart")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click:
                                        _vm.showSensitivityAnalysisChartDialog,
                                    },
                                  },
                                  [_vm._v("Sensitivity analysis")]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown d-inline-block mr-1" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-sm btn-outline-secondary dropdown-toggle",
                                  attrs: { "data-toggle": "dropdown" },
                                },
                                [
                                  _vm._v(
                                    "\n                            Edit columns\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-menu" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: { click: _vm.showGridColumnsEditor },
                                  },
                                  [_vm._v("Custom")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: { click: _vm.showSubcriteriaColumns },
                                  },
                                  [_vm._v("Subcriteria")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-divider" }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: { click: _vm.resetGridColumns },
                                  },
                                  [_vm._v("Reset")]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              attrs: { title: "Download to spreadsheet" },
                              on: { click: _vm.ExportGridCommand },
                            },
                            [_c("i", { staticClass: "fa fa-download fa-lg" })]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { attrs: { id: "mygrid" } }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v("Weights: "),
      _c("span", { staticClass: "text-danger" }, [
        _vm._v(
          "You don't have any weights sets. You can create them on the weights page."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }